import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

Injectable({ providedIn: 'root' });
export class ToasterService {
  primengMessageService = inject(MessageService);

  showCrudError(error: HttpErrorResponse): void {
    const errorMessage = this.#extractErrorMessage(error);

    this.primengMessageService.add({
      severity: 'error',
      summary: error.error?.title || 'Error',
      detail: errorMessage,
      life: 3000,
    });
  }

  #extractErrorMessage(error: HttpErrorResponse): string {
    // Handle validation errors object: {"FieldName": ["Error message 1", "Error message 2"]}
    if (error.error?.errors && typeof error.error.errors === 'object') {
      const fieldErrors = Object.values(error.error.errors);
      if (fieldErrors.length > 0 && Array.isArray(fieldErrors[0])) {
        // Get first error message from first field
        return fieldErrors[0][0] as string;
      }
    }

    // Fallback to detail or generic message
    return error.error?.detail || 'An error occurred while processing your request.';
  }

  showCrudSuccess(): void {
    this.primengMessageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Your changes have been saved.',
      life: 3000,
    });
  }
}
